import { Box, Typography } from "@mui/material";
import React from "react";
import CustomCard from "../CustomCard/CustomCard";

interface QueryPageTitleCardProps {
  title: string;
  componentItem?: React.ReactNode;
}

const QueryPageTitleCard: React.FC<QueryPageTitleCardProps> = ({
  title,
  componentItem,
}) => {
  return (
    <CustomCard
      px={2}
      py={2}
      sx={{ boxShadow: "none", border: "1px solid #DFE0EB" }}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography color={"shadesOfDark.dark"} fontSize={25} fontWeight={600}>
          {title}
        </Typography>
        {componentItem}
      </Box>
    </CustomCard>
  );
};

export default QueryPageTitleCard;
